import { useSelector } from 'react-redux';

const usePermission = (permissions) => {
    const session = useSelector((state) => state.session.session);
    const permitted = session.permissions.some((permission) => {
        if (typeof permissions === 'string') {
            return [permissions].includes(permission);
        }

        return permissions.includes(permission);
    });

    return !!permitted;
};

export default usePermission;
